import React from 'react'
import introduction_background from "../../images/introduction_background.jpg"
import {Grid} from '@mui/material';
import { Typography } from '@mui/material';
import overview_icon from "../../images/project-icon.jpg"
import mission from "../../images/mission.jpg"
import Avatar from '@mui/material/Avatar';
import business_model from "../../images/business_model.jpg"
import { makeStyles } from '@mui/styles'


const useStyles = makeStyles({
    root : {
        width : "100%", 
        backgroundColor : "black" , 
        opacity : "50%" ,
        position : "relative" 
    } ,
    bgImage : {
        width : "100%" , 
    } ,
    aboutVastraSection : {
        position : "absolute" , 
        top : "5%" , 
        direction : "rtl", 
        left : "10%" , 
        width : "20%"
    } ,
    aboutProjectSection : {
        position : "absolute" , 
        top : "60%" , 
        direction : "rtl"
    } , 
    icons : {
        display : "flex" , 
        justifyContent : "center" , 
        alignItems : "center" , 
        marginBottom : "16px"
    } ,
});

export default function Introduction() {

    const classes = useStyles();

    const typographyStyles = {
        aboutVastraTitle : {
            color : "white" , 
            fontSize : "36px" , 
            fontWeight : 700 , 
            fontFamily : "Vazir" , 
            textAlign : "center"
        } ,
        aboutVastraText : {
            color : "white" , 
            fontSize : "16px" , 
            fontWeight : 700 , 
            fontFamily : "Vazir" , 
            textAlign : "justify" ,
            lineHeight : "36px" ,
            marginTop : "16px"
        } ,
        iconText : {
            color : "white" , 
            fontSize : "24px" , 
            fontWeight : 700 , 
            fontFamily : "Vazir"
        } ,
        detailOfProjectFutures : {
            color : "white" , 
            fontSize : "16px" , 
            fontWeight : 500 , 
            fontFamily : "Vazir" ,
            lineHeight : "30px"
        } ,
        indexs : {
            fontSize : "20px" , 
            fontWeight : 500 , 
            marginLeft : "16px" , 
            color : "white" , 
            fontFamily : "Vazir"
        } , 
        listsText : {
            color : "white" , 
            fontSize : "14px" , 
            fontWeight : 500 , 
            fontFamily : "Vazir" , 
            textAlign : "justify" , 
            lineHeight : "30px"
        }
    }

    const avatarStyle = {
        width: 64, 
        height: 64 , 
        marginLeft : "24px"
    }  

    return (
        <div className={classes.root}>
            <img src={introduction_background} className={classes.bgImage}/> 
            <div className={classes.aboutVastraSection}>
                <Typography sx={typographyStyles.aboutVastraTitle} >وسترا دیجیتال</Typography>
                <Typography sx={typographyStyles.aboutVastraText}>بازوی فناورانه هلدینگ کشاورزی پاسارگاد (وسترا) برای تحول دیجیتال در زیست بوم کشاورزی کشور </Typography>
            </div>
            <Grid container spacing={2} className={classes.aboutProjectSection}>
                <Grid item xl={1} lg={1} md={1} sm={1}/>
                <Grid item xl={3} lg={3} md={3} sm={3} style={{direction : "rtl"}}>
                    <div className={classes.icons}>
                        <Avatar src={overview_icon} sx={avatarStyle}/>
                        <Typography sx={typographyStyles.iconText}>چشم انداز </Typography>
                    </div>
                    <Typography sx={typographyStyles.detailOfProjectFutures}>بزرگ‌ترین زیست‌بوم دیجیتال و خدمات نوین مالی کشاورزی ایرانیان</Typography>
                </Grid>
                <Grid item xl={4} lg={4} md={4} sm={4} style={{direction : "rtl"}}>
                    <div className={classes.icons}>
                        <Avatar src={mission} sx={avatarStyle}/>
                        <Typography sx={typographyStyles.iconText}>ماموریت</Typography>
                    </div>
                    <div style={{display : "flex"}}>
                        <Typography sx={typographyStyles.indexs}>1.</Typography>
                        <Typography sx={typographyStyles.listsText}>شناسایی کسب‌ و کارهای مبتنی بر راهکارهای فناورانه دیجیتال در صنعت کشاورزی</Typography>
                    </div>  
                    <div style={{display : "flex"}}>
                        <Typography sx={typographyStyles.indexs}>2.</Typography>
                        <Typography sx={typographyStyles.listsText}>ایجاد الگوهای همکاری و مشارکت راهبردی (سهامی و غیرسهامی)</Typography>
                    </div> 
                    <div style={{display : "flex"}}>
                        <Typography sx={typographyStyles.indexs}>3.</Typography>
                        <Typography sx={typographyStyles.listsText}>رشد و مقیاس دادن به کسب‌وکارهای کشاورزی دیجیتال با توسعه زیرساخت‌های یکپارچه دیجیتال و مالی</Typography>
                    </div> 
                    <div style={{display : "flex"}}>
                        <Typography sx={typographyStyles.indexs}>4.</Typography>
                        <Typography sx={typographyStyles.listsText}>تحول در الگوهای خلق ارزش کشاورزی با توسعه و رسوخ ابزارهای فناورانه و مالی در این صنعت</Typography>
                    </div>                   
                </Grid>
                <Grid item xl={3} lg={3} md={3} sm={3} style={{direction : "rtl"}}>
                    <div className={classes.icons}>
                        <Avatar src={business_model} sx={avatarStyle}/>
                        <Typography sx={typographyStyles.iconText}>الگوی کسب و کار</Typography>
                    </div>
                    <Typography sx={typographyStyles.detailOfProjectFutures}>ایجاد امکان هم افزایی بین سرویس های مالی و بانکی با خدمات مشاوره داده مبنا برای مزرعه هوشمند در مزارع پسته
(اپلیکیشن کاوشگران) ، بازارگاه تبادل عمده محصوالت کشاورزی (بازارگاه سروبان) و خدمات کشاورزی هوشمند (اپلیکیشن 
سیرنگ) و خلق مدل کسب وکاری جدید با قابلیت مقیاس پذیری
</Typography>
                </Grid>
                <Grid item xl={1} lg={1} md={1} sm={1}/>
            </Grid>
        </div>
    )
}